<template>
      <b-container class="overflow-auto transaction-history">
        <div v-if="items.length>0" id="infinite-list">
          <b-card v-for="(item,index) in items" no-body class="mb-1" :key="index">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-row v-b-toggle="'transaction_' + index" class="table-row pt-3 pb-3 mt-1 mb-1 rounded">
                <b-col xs="12" md="10">
                  <div class="d-flex align-items-center">
                      <!-- <img v-if="item.icon=='restaurant'" :src="`${publicPath}/img/rcp/card/icon/${item.icon}.png`"/> -->
                      <div class="ml-1">
                          <div class="caption">{{item.date}} | <span class="text-uppercase">{{ item.time }}</span></div>
                          <div class="fz-22 fw-600">{{ item.description }}</div>
                      </div>
                      <div v-if="item.status!='void'" class="status text-right ml-3">
                        <div :class="'badge-default badge-'+item.status.toLowerCase()">{{ $t(item.status.charAt(0).toUpperCase() + item.status.slice(1)) }}</div>
                      </div>
                  </div>
                </b-col>
                <b-col xs="12" md="2">
                  <div class="fz-22 fw-600" v-if="item.balance">{{ item.balance }} {{ item.currency }}</div>
                  <div :class="(item.type=='in'?'text-green ':'')+'caption'">{{item.type=="in"?"+":""}}{{item.transaction_amount}} {{item.transaction_currency}}</div>
                </b-col>
              </b-row>
            </b-card-header>
            <b-collapse :id="'transaction_'+index" accordion="my-accordion" role="tabpanel" class="expand">
                <b-card-body class="pl-5 pr-5">
                  <b-row>
                    <b-col xs="12" md="10">
                      <div class="fz-12">{{ $t('Transaction ID') }} : {{ item.id }}</div>
                      <!-- <div class="caption">{{ item.date }} | <span class="text-uppercase">{{ item.time }}</span></div> -->
                      <div>{{ item.merchant_name }}</div>
                      <div class="caption">{{ $t('Gross Amount') }} {{ item.gross_amount }} </div>
                    </b-col>
                    <!-- <b-col xs="12" md="2">
                      <div class="fw-600 fz-18">{{ item.balance }} {{ item.currency }}</div>
                      <div :class="(item.type=='in'?'text-green ':'')">{{item.type=="in"?"+":""}}{{item.transaction_amount}} {{item.transaction_currency}}</div>
                    </b-col> -->
                  </b-row>
                </b-card-body>
            </b-collapse>
          </b-card>
          <transition name="fade">
            <div class="loading fz-20 fw-500" v-show="loading && !completedLoad">
              <span class="fa fa-spinner fa-spin"></span> Loading
            </div>
          </transition>
        </div>
        <div v-else class="p-4 m-2 text-center text-muted nodata">
          <div v-if="isLoading" class="dot-loading">
            <ul class="loader-circle">
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <span v-else>
            {{ $t('No transaction available') }}
          </span>
        </div>
    </b-container>
  </template>
  
  <script>
  
    import Common from '@/services/Common';
    import moment from 'moment';

    export default {
    name: 'transaction-history-table',  
    data() {
        return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            isLoading:false,
            loading:false,
            currentPageToken:'',
            completedLoad:false,
            result_data:[],
            card:{},
            fields:[
                { key: 'description'},
                { key: 'transaction_amount', class: 'text-right pr-5' },
            ],
            items:[]
        }
      },
      props:['current_card'],
      methods:{
        loadMore () {
          if(this.loading == false && !this.completedLoad){
            this.loading = true;
            setTimeout(e => {
              this.getList();
            }, 200);
          }
        },
        getList(){
          this.isLoading = true;
          var opt = {
            cardAccountId  : this.card.card_account_id,
            cardId         : this.card.card_id,
            pageSize       : 20
          };

          
          if(this.currentPageToken){
            opt.pageToken = this.currentPageToken;
          }

          Common.transaction(opt).then(response => {
              if(response.status == 200){
                this.isLoading = false;
                this.loading = false;
                if(response.data.data){
                  const list = response.data.data.transactions;

                  if(list && list.length>0){
                    const find = this.items.find(o => o.id === list[0].id);

                    this.currentPageToken = (!find && response.data.data.nextPageToken)?response.data.data.nextPageToken:'';

                    const type = (list)?(list.entryType=="DEBIT"?"in":"out"):'';

                    for (const key in list) {
                      const item = list[key];
                      
                      this.items.push({
                        "id":item.id,
                        "date":moment(item.createdAt).format('DD MMMM YYYY'),
                        "time":moment(item.createdAt).format('H:mm a'),
                        "description":item.description,
                        "type":type,
                        "merchant_name":item.merchant.name,
                        "icon":(item.merchant && item.merchant.category)?(item.merchant.category.toLowerCase().indexOf("food")!=-1?"restaurant":type):type,
                        "transaction_amount":item.amount,
                        "transaction_currency":item.currency,
                        "balance":(item.authorization && item.authorization.amount)?item.authorization.amount:"",
                        "currency":(item.authorization && item.authorization.currency)?item.authorization.currency:"",
                        "gross_amount":item.grossAmount,
                        "status":item.status
                      });
                    }
                  }
                  else{
                    this.currentPageToken = '';
                    this.completedLoad = true;
                  }
                  
                }
                else{
                  console.log("no data");
                }
              }
          })
          .catch(err => {
            this.isLoading = false;
            this.checkError(err);
          });

        },
        onChange(index){
          console.log(index);
          this.card = this.result_data[index];
          this.items = [];
          this.getList(); 
        },
        checkError(err){  
          try{
            const response = err.response;
            if(response.status == 401 && response.data.name == "Unauthorized"){
              localStorage.removeItem("token");
              localStorage.removeItem("member");
              localStorage.removeItem("isFirstTime");
              this.$router.push({ 
                path: '/login', 
              });
            }
            else{
              var msg = (err.response.data)?err.response.data.message:err.message;
              this.$notify({
              type: 'warn',
              text: msg
              })
            }
          }catch(e){
            console.log(err);
          }
        }
      },
      mounted(){
        this.items = [];
        Common.card_active().then(response => {
            if(response.status == 200){
                const result = response.data.data;
                this.result_data = result;
                  this.card = result[this.current_card];
                  if(this.card){
                    this.getList();
                  }
            }
        }).catch(err => {
            this.checkError(err);
        });

        // Detect when scrolled to bottom.
          window.addEventListener('scroll', e => {
            const getScrollPosition = (el = window) => ({
              x: el.pageXOffset !== undefined ? el.pageXOffset : el.scrollLeft,
              y: el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
            });
            const body = document.body,
                  html = document.documentElement;

            const height = Math.max( body.scrollHeight, body.offsetHeight, 
                                  html.clientHeight, html.scrollHeight, html.offsetHeight );
            const position = getScrollPosition();
            if(position.y>=height-screen.height){
              this.loadMore();
            }
          });
      },
      computed: {
       
      }
    }
  </script>

<style>
.badge-pending,
.badge-default{
    color: #5521B5;
    background-color: #EDEBFE;
    font-weight: 500;
    font-size: 12px;
    border-radius: 50px;
    text-align: center;
    padding: 10px 10px;
}

.badge-approved,
.badge-posted{
    color: #037F0C;
    background-color: #EFF9E4;
    font-weight: 500;
    font-size: 12px;
    border-radius: 50px;
    text-align: center;
    padding: 10px 10px;
}

.badge-rejected,
.badge-declined{
    color: #D91515;
    background-color: #FFECEE;
    font-weight: 500;
    font-size: 12px;
    border-radius: 50px;
    text-align: center;
    padding: 10px 10px;
}
.loading {
  text-align: center;
  z-index: 9;
  padding: 8px 18px;
  border-radius: 5px;
  left: calc(50% - 45px);
  top: calc(50% - 18px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>